import {bulkUpdate} from 'utils/bulkUpdate.js';
import {saveParameterToJson, loadParameterFromJson} from 'parameters/parameterJsonFunctions.js';
export default superclass => class extends superclass  {
    parameters = [];

    registerParameter(parameter) {
        if (this.store) {
            parameter.setStore(this.store);
        }
        this.parameters.push(parameter);
    }

    getParameters() {
        return this.parameters.filter(
            x => x);
    }

    getJson() {
        let json = {
            name: this.name,
            id: this.id,
            x: this.x,
            y: this.y,
        };

        for (let i in this.parameters) {
            let parameter = this.parameters[i];
            if (!parameter) {
                continue;
            }
            json[parameter.name] = parameter.get();
            let fullParameterName = parameter.name + 'Parameter';
            json = saveParameterToJson(
                json, fullParameterName, parameter, this.sequencerEngine);
        }

        return json;
    }

    fromJson(json, isCopy=false) {
        if (json.id !== undefined && !isCopy) {
            this.id = json.id;
        }

        if (json.x !== undefined) {
            this.x = json.x;
            this.y = json.y;
        }

        let bulk = {};

        for (let i in this.parameters) {
            let parameter = this.parameters[i];
            if (!parameter) {
                continue;
            }
            let value = json[parameter.name];
            if (value !== undefined && value !== null) {
                bulkUpdate(parameter, value, bulk);
            }
            bulk = {
                ... bulk,
                ... loadParameterFromJson(
                    json, parameter.name + 'Parameter', parameter, this.sequencerEngine, isCopy)
            };
        }
        return bulk;
    }
}
